import { render, staticRenderFns } from "./MessagesFeedGroup.vue?vue&type=template&id=1fc191a6&scoped=true"
import script from "./MessagesFeedGroup.vue?vue&type=script&lang=js"
export * from "./MessagesFeedGroup.vue?vue&type=script&lang=js"
import style0 from "./MessagesFeedGroup.vue?vue&type=style&index=0&id=1fc191a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc191a6",
  null
  
)

export default component.exports